import React, { useEffect } from 'react';

export const Hero: React.FC = () => {
  // Preload images
  useEffect(() => {
    const preloadImages = () => {
      const imageSizes = ['small', 'medium', 'large'];
      imageSizes.forEach(size => {
        const img = new Image();
        img.src = `/images/hero-bg-${size}.webp`;
      });
    };
    preloadImages();
  }, []);

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center pt-20 pb-16"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 opacity-25">
        <picture>
          <source 
            media="(max-width: 640px)" 
            srcSet="/images/hero-bg-small.webp"
          />
          <source 
            media="(max-width: 1024px)" 
            srcSet="/images/hero-bg-medium.webp"
          />
          <img
            src="/images/hero-bg-large.webp"
            alt=""
            className="w-full h-full object-cover"
            loading="eager"
          />
        </picture>
      </div>

      {/* Centered Responsive Text */}
      <div className="container px-4 md:px-6 relative z-10">
        <div className="flex flex-col items-center justify-center text-center space-y-10">
          {/* Motto as the Larger Title */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Explore • Reflect • Transcend
          </h1>

          {/* Supporting Statements */}
          <div>
            <p className="text-2xl sm:text-2xl md:text-3xl lg:text-4xl text-white/90 leading-relaxed max-w-2xl">
              Generalists Rule The World.
            </p>
            <p className="mt-2 text-2xl sm:text-2xl md:text-3xl lg:text-4xl text-white/90 leading-relaxed max-w-2xl">
              Keep Learning.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
